import React from 'react';
import AppContext from '../../../AppContext';
import { FlexBox, H4 } from '../../../Components';
import { getCurrentOrder } from '../../../selectors';
import {
  isActiveOrderBeingViewedForTheFirstTimePostSync,
  markOrderAsSeen,
} from '../../../utils/viewedOrdersArray';
import { getTranslateByScope } from '../../../i18n';

const translate = getTranslateByScope('app.closeOrder');

const SyncedOrderBanner = () => {
  const context = React.useContext(AppContext);

  const currentOrder = getCurrentOrder(context);
  React.useEffect(() => {
    return () => {
      if (!currentOrder) {
        return;
      }
      const { doc } = currentOrder;

      if (!doc) {
        return;
      }
      if (doc.status === 'done') {
        return;
      }
      if (isActiveOrderBeingViewedForTheFirstTimePostSync(doc.id)) {
        markOrderAsSeen(doc.id);
      }
    };
  }, [currentOrder]);

  if (!currentOrder) {
    return <></>;
  }
  const { doc } = currentOrder;

  if (!doc) {
    return <></>;
  }

  if (doc.status === 'done') {
    return <></>;
  }

  if (!isActiveOrderBeingViewedForTheFirstTimePostSync(doc.id)) {
    return <></>;
  }

  return (
    <FlexBox justifyContent='center' marginTop='md' marginBottom='md'>
      <H4>{translate('postSyncBanner')}</H4>
    </FlexBox>
  );
};

export default SyncedOrderBanner;
